var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20936_8970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2783 12.1846C17.6002 12.0548 17.9518 12.2271 18.0898 12.5576C18.2342 12.9018 18.1115 13.327 17.7861 13.502L9.28516 18.0771C9.19547 18.1253 9.09756 18.1504 8.99902 18.1504C8.90072 18.1504 8.80346 18.1252 8.71387 18.0771L0.213867 13.502C-0.111727 13.3269 -0.234175 12.9018 -0.0898438 12.5576C0.0579562 12.2053 0.448897 12.033 0.786133 12.2148L8.99902 16.6357L17.2148 12.2148L17.2783 12.1846ZM-0.0234375 8.57617C0.154274 8.31018 0.48866 8.19631 0.78418 8.35645H0.785156L8.99902 12.7773L17.2148 8.35645C17.5522 8.17537 17.9413 8.34634 18.0889 8.69922C18.2336 9.04367 18.1113 9.46813 17.7861 9.64355L9.28516 14.2188C9.19601 14.2666 9.09815 14.291 8.99902 14.291C8.90016 14.291 8.80289 14.2665 8.71387 14.2188L0.214844 9.64355C-0.110938 9.4684 -0.234516 9.04365 -0.0898438 8.69922L-0.0234375 8.57617ZM8.7832 -0.109375C8.92309 -0.163416 9.07594 -0.163422 9.21582 -0.109375L9.28516 -0.078125L17.7861 4.49902C18.0145 4.62218 18.1504 4.87569 18.1504 5.14258C18.1504 5.40897 18.014 5.66246 17.7852 5.78516L9.28516 10.3613C9.19601 10.4092 9.09816 10.4346 8.99902 10.4346C8.90019 10.4345 8.80287 10.4091 8.71387 10.3613L0.214844 5.78613C-0.0140237 5.66343 -0.149409 5.40897 -0.149414 5.14258C-0.149414 4.87576 -0.0143226 4.6222 0.214844 4.49902L8.71387 -0.078125L8.7832 -0.109375ZM1.97949 5.1416L8.99902 8.91992L16.0195 5.1416L8.99902 1.36328L1.97949 5.1416Z",
    fill: "#009BE5",
    stroke: "#009BE5",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20936_8970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.b8145e06f39bcd68257353c2fa62a44b.svg";
export { ForwardRef as ReactComponent };